import { CircleDollarSign } from 'lucide-react'
import type { Expense } from '@/features/expenses/types/expenses'
import { Badge } from '@/components/custom/badge'
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'
import { ExpenseCard } from '@/features/expenses/components/ExpenseCard'
import { useIsMobile } from '@/hooks'

type PendingExpensesProps = {
  expenses: Array<Expense>
  onOpenDetails: (expenseId: string) => void
}

export function PendingExpenses({
  expenses,
  onOpenDetails,
}: PendingExpensesProps) {
  const isMobile = useIsMobile()

  if (!isMobile) {
    return (
      <div className="bg-white rounded-lg border">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <CircleDollarSign className="h-5 w-5 text-yellow-600 mr-2" />
              <h2 className="text-lg font-medium text-gray-900">
                Pending Expenses
              </h2>
            </div>
            <Badge color="yellow">{expenses.length} pending</Badge>
          </div>
        </div>
        <div className="p-6">
          {expenses.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-500">No pending expenses approval</p>
            </div>
          ) : (
            <ScrollArea className="w-full overflow-x-auto">
              <div className="inline-flex gap-4 w-[75vw]">
                {expenses.map((expense) => (
                  <ExpenseCard
                    key={expense._id}
                    expense={expense}
                    onDetail={() => onOpenDetails(expense._id)}
                  />
                ))}
              </div>
              <ScrollBar orientation="horizontal" />
            </ScrollArea>
          )}
        </div>
      </div>
    )
  }

  return expenses.length === 0 ? (
    <div className="text-center py-8">
      <p className="text-gray-500">No expenses pending approval</p>
    </div>
  ) : (
    <ScrollArea className="flex-1">
      <div className="space-y-3">
        {expenses.map((expense) => (
          <ExpenseCard
            key={expense._id}
            expense={expense}
            onDetail={() => onOpenDetails(expense._id)}
          />
        ))}
      </div>
    </ScrollArea>
  )
}
